<template>
  <drill-report-base v-bind="$route.query" :record-id="$route.query.id" />
</template>

<script lang="ts">
import DrillReportBase from './DrillReportBase.vue'
import { BasePage, Component } from 'kuaidong-component'

@Component({
  components: {
    DrillReportBase,
  },
})
export default class DrillReport extends BasePage {}
</script>

<style lang="scss">
.drill-report-page {
}
</style>
